import { render, staticRenderFns } from "./goodMessage.vue?vue&type=template&id=41afb4ba&scoped=true"
import script from "./goodMessage.vue?vue&type=script&lang=js"
export * from "./goodMessage.vue?vue&type=script&lang=js"
import style0 from "./goodMessage.vue?vue&type=style&index=0&id=41afb4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41afb4ba",
  null
  
)

export default component.exports